import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import sweetalert2 from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import {
    updateQuoteTemp,
    getTags,
    getCommonTemplet,
    getTempletCategary,
    getReplyTo,
    getSingleTemplet
} from "../../../ReduxStore/Slice/Templets/QuotesTemplets";
import {
    EMPTY_TEMPLET_NAME_ERROR,
    EMPTY_TEMPLET_CATEGORY_ERROR,
    EMPTY_TEMPLET_BODY_ERROR
} from '../../../Utils/Common_Error'
import { useLocation } from "react-router-dom";
import JoditEditor from 'jodit-react';
import * as Config from "../../../Utils/Config";
import axios from 'axios';



const CreateEmailTemplate = () => {
    const editor = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));
    const [activeTab, setActiveTab] = useState("Client");

    const location = useLocation();
    const token = localStorage.getItem("token");
    const [content, setContent] = useState('');
    const [error, setError] = useState({})
    const [editorReady, setEditorReady] = useState(false);
    const [getTagsData, setTagsData] = useState({ client: [], practice: [], user_profile: [], others: [], })
    const [getCommonTempletData, setCommonTempletData] = useState([])

    console.log("getCommonTempletData", getCommonTempletData)
    const [gettempletCatagryData, setTempletCatagaryData] = useState([])
    const [ReplyToData, setReplyToData] = useState([])
    const [formData, setFormData] = useState({
        templateName: "",
        description: "",
        template_category: [],
        subjectLine: "",
        bccEmail: "",
        replyTo: "",
        body: "",
        attachments: [],
    });

    useEffect(() => {
        if (getCommonTempletData.length > 0 || gettempletCatagryData.length > 0 && ReplyToData.length > 0) {
            SingleTemplet()
        }
    }, [getCommonTempletData, gettempletCatagryData, ReplyToData, getTagsData]);

    useEffect(() => {
        CommonTemplet()
        templetCatagery()
        ReplyTo()
        Tags()
    }, [])

    const SingleTemplet = async () => {
        const req = { id: location?.state?.id, agent_id: agent_id };
        await dispatch(getSingleTemplet(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    setFormData({
                        templateName: res?.data?.name,
                        description: res?.data?.description,
                        //template_category: [{ label: res?.data?.QuoteTemplateCategories?.[0]?.TemplateCategory?.name, value: res?.data?.QuoteTemplateCategories?.[0]?.TemplateCategory?.id }],
                        template_category: res?.data?.enquirytype
                            ? res?.data?.enquirytype.split(',').map(item => ({ label: item.trim(), value: item.trim() }))
                            : [],
                        subjectLine: res?.data?.subject,
                        bccEmail: res?.data?.bcc_mail,
                        replyTo: res?.data?.reply_to,
                        body: res?.data?.body,
                        attachments: res?.data?.attachment,
                    })
                }
                else {
                    setFormData([])
                }
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }

    const ReplyTo = async () => {
        const req = { agent_id: agent_id };
        await dispatch(getReplyTo(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    setReplyToData(res.data)
                    setFormData({ ...formData, replyTo: res?.data[0]?.id })
                }
                else {
                    setReplyToData([])
                }
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }

    const Tags = async () => {
        const req = { agent_id: agent_id };
        await dispatch(getTags(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    const filterClient = res.data.filter((data) => data.type == "client")
                    const filterPractice = res.data.filter((data) => data.type == "practice")
                    const filterUserProfile = res.data.filter((data) => data.type == "user_profile")
                    const filterOther = res.data.filter(
                        (data) => data.type == "other"
                    )
                    setTagsData({ client: filterClient, practice: filterPractice, user_profile: filterUserProfile, others: filterOther })
                }
                else {
                    setTagsData({ client: [], practice: [], user_profile: [], others: [] })
                }
            })
            .catch((err) => {

            })
    }
    const CommonTemplet = async () => {
        const req = { agent_id: agent_id };
        await dispatch(getCommonTemplet(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    setCommonTempletData(res.data)
                }
                else {
                    setCommonTempletData([])

                }
            })
            .catch((err) => {
                console.log("Error ", err)
            })

    }

    const templetCatagery = async () => {
        const req = { agent_id: agent_id };
        await dispatch(getTempletCategary(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    setTempletCatagaryData(res.data)
                }
                else {
                    setTempletCatagaryData([])
                }
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }



const UpdateFormBody = useCallback((value) => {
    if (editor.current && editor.current.selection) {
        const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;
        editor.current.selection.insertHTML(imgTag);
    }
}, []);

const cleanWordHtml = (html = "") => {
  if (!html) return html;

  html = html.replace(/<style[\s\S]*?<\/style>/gi, "");
  
  html = html.replace(/<!--[\s\S]*?-->/g, "");
  
  html = html.replace(/mso-[a-z\-]+\s*:[^;"]+(;|")/gi, "");
  
  
  return html;
};

const config1 = useMemo(
  () => ({
    readonly: false,
    placeholder: "",
    buttons:
      "bold,italic,underline,strikethrough,ul,ol,paragraph,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
    removeButtons: ["speechRecognize"],
    toolbarSticky: false,

    style: {
      font: '14px "Times New Roman", Arial, sans-serif',
      color: "#000000",
      lineHeight: "1.4",
    },

    controls: {
      font: {
        list: {
          Poppins: '"Poppins", sans-serif',
          Arial: "Arial, Helvetica, sans-serif",
          "Times New Roman": '"Times New Roman", Times, serif',
          Roboto: "Roboto, sans-serif",
          Verdana: "Verdana, Geneva, sans-serif",
        },
      },
    },

    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",  
    defaultActionOnPasteFromWord: "insert_clear_html",  
    
    processPasteHTML: (html) => {
      return cleanWordHtml(html);  
    },
    
    processPasteFromWord: (html) => {
      return cleanWordHtml(html);  
    },

    uploader: {
      url: Config.base_url + "img/uploader",
      accept: "image/*,video/*",
      method: "POST",
      withCredentials: false,
      prepareData: async (formData1) => {
        const data = new FormData();
        formData1.forEach((file) => {
          data.append("files[0]", file);
        });

        try {
          const response = await axios.post(
            Config.base_url + "img/uploader",
            data,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (
            response.data.success &&
            Array.isArray(response.data.files) &&
            response.data.files.length > 0
          ) {
           
            UpdateFormBody(response.data.files[0]);
            return {
              success: true,
              files: response.data.files,
              messages: response.data.messages || ["Image uploaded successfully"],
            };
          } else {
            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          }
        } catch (error) {
          console.error("Image upload error:", error);
          return {
            success: false,
            files: [],
            messages: ["Image upload failed"],
          };
        }
      },
      
      defaultHandlerSuccess: (response) => {
        if (response?.files?.length > 0) {
          return response.files;
        } else {
          console.error("No files in response:", response);
          return [];
        }
      },
      
      defaultHandlerError: (error) => {
        console.error("Image upload error:", error);
        return [];
      },
    },

    events: {
      afterInit: (editorInstance) => {
        setEditorReady(true);
        editor.current = editorInstance;
      },
    },
  }),
  [UpdateFormBody]
);


    const handleSubmit = async () => {
        const req = { formData: formData, id: location?.state?.id, agent_id: agent_id };
        const isValid1 = validateAllFields()
        if (!isValid1) {
            return;
        }
        await dispatch(updateQuoteTemp(req)).unwrap()
            .then((res) => {
                if (res.status) {
                    sweetalert2.fire({
                        title: 'Success',
                        text: res.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        timer: 3000,
                        timerProgressBar: true
                    })
                    setTimeout(() => {
                        navigate("/admin/template/all-quote-template")
                    }, 3000)
                }
                else {
                    sweetalert2.fire({
                        title: 'Error',
                        text: res.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
            .catch((err) => {

            })
    }

    const handleAttachmentChange = (e) => {
        const files = Array.from(e.target.files);
        setFormData({
            ...formData,
            attachments: [...formData.attachments, ...files],
        });
    };

    const handleRemoveAttachment = (index) => {
        const updatedAttachments = formData.attachments.filter(
            (_, i) => i !== index
        );
        setFormData({ ...formData, attachments: updatedAttachments });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        validate(name, value)
    };

    const validateAllFields = () => {
        let isValid = true;
        for (const key in formData) {
            if (!validate(key, formData[key])) {
                isValid = false;
            }
        }
        return isValid;
    };

    const deleteErrorMsg = (name) => {
        setError((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
    }

    const validate = (name, value) => {
        const newErrors = { ...error };
        if (!value) {
            switch (name) {
                case "templateName":
                    newErrors.templateName = EMPTY_TEMPLET_NAME_ERROR;
                    break;
                case "body":
                    newErrors.body = EMPTY_TEMPLET_BODY_ERROR;
                    break;
                default:
                    break;
            }
        }
        else if (name == "template_category") {

            if (value.length == 0) {
                newErrors.template_category = EMPTY_TEMPLET_CATEGORY_ERROR;
            }
            else {
                delete newErrors[name];
                deleteErrorMsg(name);
            }
        }

        if (Object.keys(newErrors).length !== 0) {
            setError((prevErrors) => ({
                ...prevErrors,
                ...newErrors,
            }));
        }

        return Object.keys(newErrors).length === 0;
    }

    const ReplacePartial = (str) => {
        return str.replace("PARTIAL_", "")
    }

    const insertTag = (tag) => {
        if (editorReady && editor.current) {
            const editorInstance = editor.current;
            if (editorInstance && editorInstance.selection) {
                editorInstance.selection.insertHTML(`{{${tag?.name?.toUpperCase()}}}\t\t`);
            }
        }
    };

    const tags = [
        { id: "Client", name: "Client", },
        { id: "Practice", name: "Practice", },
        { id: "User_Profile", name: "User Profile", },
        { id: "others", name: "Others", },
    ]



    return (
        <div>
            <div className="row mb-3">
                <div className="col">
                    <h4 className="page-title">
                        <Link to="/admin/template/all-quote-template">
                            <i className="bx bx-arrow-back text-pink pe-1"></i>
                        </Link>
                        Edit Quote Template
                    </h4>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body tempaltes">
                            <div className=" needs-validation" >
                                <div className="row mb-4">
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Template name:
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="templateName"
                                                    onChange={handleInputChange}
                                                    value={formData.templateName}
                                                />
                                                {error.templateName && <div className="error-text">{error.templateName}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12  mb-3">
                                        <div className="row">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Description:
                                            </label>
                                            <div className="col-sm-9">
                                                <textarea
                                                    className="form-control"
                                                    name="description"
                                                    onChange={handleInputChange}
                                                    value={formData.description}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12  mb-3">
                                        <div className="row">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Template Category :
                                            </label>
                                            <div className="col-sm-9">
                                                <Select
                                                    options={gettempletCatagryData?.map((data) => {
                                                        return { label: data.name, value: data.name }
                                                    })}
                                                    isMulti
                                                    className="basic-multi-select"
                                                    placeholder="Select options"
                                                    name="template_category"
                                                    closeMenuOnSelect={false}
                                                    onChange={(e) => { setFormData({ ...formData, template_category: e }); validate("template_category", e) }}
                                                    value={formData.template_category}
                                                />
                                                {error?.template_category && <div className="error-text">{error.template_category}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12  mb-3">
                                        <div className="row">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Subject:
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="subjectLine"
                                                    onChange={handleInputChange}
                                                    value={formData.subjectLine}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12  mb-3">
                                        <div className="row">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                BCC Email:
                                            </label>
                                            <div className="col-sm-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="bccEmail"
                                                    onChange={handleInputChange}
                                                    value={formData.bccEmail}
                                                />
                                            </div>
                                            <div className="col-sm-1 ps-0"><span>
                                                <i className='bx bx-info-circle fs-4 mt-1'></i>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12  mb-3">
                                        <div className="row ">
                                            <label
                                                htmlFor="inputEmail3"
                                                className="col-sm-3 col-form-label"
                                            >
                                                Reply to:
                                            </label>
                                            <div className="col-sm-6">
                                                <select className="form-select"
                                                    name="replyTo"
                                                    onChange={handleInputChange}
                                                    value={formData.replyTo}
                                                >
                                                    {ReplyToData.map((data) => (
                                                        <option value={data.id}>{data.email}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-sm-1 ps-0"><span>
                                                <i className='bx bx-info-circle fs-4 mt-1'></i>
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <label className="col-sm-12 col-form-label">
                                                Body:
                                            </label>
                                            <div className="col-sm-12">
                                                <JoditEditor
                                                    ref={editor}
                                                    config={config1}
                                                    tabIndex={1}
                                                    onBlur={(newContent) => setContent(newContent)}
                                                    name="body"
                                                    onChange={(value) => {
                                                        setFormData({ ...formData, body: value });
                                                        validate("body", value);
                                                    }}
                                                    value={formData.body || ""}
                                                />
                                                {error.body && <div className="error-text">{error.body}</div>}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <div className="row">
                                        <div className="col-sm-3"></div>
                                        <div className="col-sm-9">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={() => document.getElementById("fileInput").click()}
                                            >
                                                <i className="bi bi-paperclip me-2"></i>
                                                Add Attachment
                                            </button>
                                            <input
                                                id="fileInput"
                                                type="file"
                                                multiple
                                                onChange={handleAttachmentChange}
                                                className="d-none"
                                            />
                                         <div className="attachment-list mt-3">
  {formData?.attachments?.map((file, index) => (
    <div
      key={index}
      className="attachment-item d-flex align-items-center justify-content-between mb-2 p-2"
    >
      <div className="d-flex align-items-center gap-2">
        <div className="file-icon">
          <i className="bi bi-paperclip"></i>
        </div>

        <span className="file-name">{file?.name}</span>
      </div>

      <button
        type="button"
        className="btn btn-sm btn-light-danger remove-btn"
        onClick={() => handleRemoveAttachment(index)}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
  ))}
</div>

                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <div className="col-md-9">
                                        <div className="card mt-2">
                                            <div className="card-header py-1 d-flex justify-content-between align-items-center">
                                                <div className="card-title">Templates</div>

                                            </div>
                                            <div className="card-body pt-3">
                                                <div className="tag-buttons">
                                                    {getCommonTempletData?.map((item, index) => (
                                                        <button className="tag-btn" onClick={() => insertTag(item)}>
                                                            <i className="bi bi-plus-lg" />
                                                            {ReplacePartial(item.name)}
                                                        </button>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-auto text-end">
                                    <button className="btn btn-outline-secondary rounded" onClick={() => navigate("/admin/template/all-quote-template")}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-pink rounded ms-2" onClick={handleSubmit}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="quill-editor-full"></div>
                </div>
                <div className="col-md-4">
                    <div className="card pt-3 px-2 sticky-card">
                        <h5 className="text-gray">
                            Tag Provision <i className="bx bx-info-circle text-pink"></i>
                        </h5>
                        <ul className="nav nav-tabs nav-tabs-bordered d-flex" role="tablist">
                            {tags.map((tag) => (
                                <li className="nav-item flex-fill" role="presentation" key={tag.id}>
                                    <button
                                        className={`nav-link ${activeTab === tag.id ? "active" : ""}`}
                                        id={tag.id}
                                        data-bs-toggle="tab"
                                        data-bs-target={`#tab-${tag.id}`}
                                        type="button"
                                        role="tab"
                                        aria-controls={`tab-${tag.id}`}
                                        aria-selected={activeTab === tag.id}
                                        onClick={() => setActiveTab(tag.id)}
                                    >
                                        {tag.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content p-3">
                            {/* Client Tab */}
                            <div
                                className={`tab-pane fade ${activeTab === "Client" ? "show active" : ""}`}
                                id="tab-Client"
                                role="tabpanel"
                                aria-labelledby="Client"
                            >
                                <div className="tag-buttons">
                                    {getTagsData.client.map((tag) => (
                                        <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                                            {"+ " + (tag?.name === "clientCompanyDirectorAddress" ? "DirectorAddress".toUpperCase() :
                                                tag?.name?.toUpperCase())}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Practice Tab */}
                            <div
                                className={`tab-pane fade ${activeTab === "Practice" ? "show active" : ""}`}
                                id="tab-Practice"
                                role="tabpanel"
                                aria-labelledby="Practice"
                            >
                                <div className="tag-buttons">
                                    {getTagsData.practice.map((tag) => (
                                        <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                                            {"+ " + (tag?.name === "company_name" ? "AccountantCompanyName".toUpperCase() :
                                                tag?.name === "incorporated_in" ? "AccountantCompanyIncorporatedIn".toUpperCase() :
                                                    tag?.name === "company_no" ? "AccountantCompanyRegNumber".toUpperCase() :
                                                        tag?.name === "agent_registered_address" ? "AccountantCompanyRegAddress".toUpperCase() :
                                                            tag?.name === "name_of_the_affiliated_accouting_body" ? "NameOfTheAffiliatedAccountingBody".toUpperCase() :

                                                                tag?.name?.toUpperCase())}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === "User_Profile" ? "show active" : ""}`}
                                id="tab-User_Profile"
                                role="tabpanel"
                                aria-labelledby="User_Profile"
                            >
                                <div className="tag-buttons">
                                    {getTagsData.user_profile.map((tag) => (
                                        <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                                            {"+ " + tag?.name?.toUpperCase()}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div
                                className={`tab-pane fade ${activeTab === "others" ? "show active" : ""}`}
                                id="tab-Others"
                                role="tabpanel"
                                aria-labelledby="Others"
                            >
                                <div className="tag-buttons">
                                    {getTagsData.others?.map((tag) => (
                                        <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                                            {"+ " + tag?.name?.toUpperCase()}
                                        </button>
                                    )) || <p>No tags available.</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateEmailTemplate;
